export default function () {
  document.getElementById("k-main-right")?.scrollTo(0, 0);
  const divs = document.getElementsByClassName(
    "custom-container"
  ) as HTMLCollectionOf<HTMLDivElement>;
  if (divs?.length) {
    divs[0]?.scrollTo(0, 0);
  }
}
